import { IServiceCardData } from "./card.view";
import { IMunicipalityConfig } from "../config/municipalityConfig";
import { IRoleChooser, Role } from "../roleChooser/roleChooserTypes";

/**
 * Generates an array of card data based on the users role.
 * Used for generating UI for available services
 * @param roles
 */

export function createServiceCardData(
  roles: IRoleChooser,
  configValues?: IMunicipalityConfig
): IServiceCardData[] {
  const cards = [];
  let privatePersonRoles: IRoleChooser[] = [];
  let organisationRepRoles: IRoleChooser[] = [];

  if (!!roles[Role.PRIVATE]) {
    privatePersonRoles = Object.values(roles[Role.PRIVATE]);
    if (!!!configValues?.profileService.hideService)
      cards.push({
        path: "/profil",
        header: "Min profil",
        body: configValues
          ? configValues?.profileService.cardText
          : "Kontaktopplysningene vi har registrert om deg.",
      });
    if (
      configValues?.inboxService.enabled &&
      !!!configValues?.inboxService.hideService
    )
      cards.push({
        path: "/post-fra-kommunen",
        header: "Post fra kommunen",
        body: configValues
          ? configValues?.inboxService.cardText
          : "Digitale brev sendt til \n deg fra kommunen.",
      });
  }

  if (
    configValues?.invoiceService.enabled &&
    !!!configValues?.invoiceService.hideService
  )
    cards.push({
      path: "/faktura",
      header: "Faktura",
      body: configValues
        ? configValues?.invoiceService.cardText
        : "Fakturaer som er sendt til deg fra kommunen.",
    });

  if (!!roles[Role.ORGREP]) {
    organisationRepRoles = Object.values(roles[Role.ORGREP]);
  }

  const combinedValues = [...privatePersonRoles, ...organisationRepRoles];
  if (
    combinedValues.some(
      (subRole) => Object.keys(subRole).toString() === Role.ESTATEOWNER
    )
  ) {
    if (!!!configValues?.estateService.hideService)
      cards.push({
        path: "/eiendommer",
        header: "Eiendommer",
        body: configValues
          ? configValues?.estateService.cardText
          : "Dokumenter og informasjon om \n dine eiendommer.",
      });
    if (
      configValues?.propertyTaxService?.enabled &&
      !!!configValues?.propertyTaxService?.hideService
    )
      cards.push({
        path: "/eiendomsskatt",
        header: "Eiendomsskatt",
        body: configValues
          ? configValues?.propertyTaxService.cardText
          : "Vedtatt eiendomsskatt \n og beregning.",
      });

    if (
      configValues?.waterAndWasteService?.enabled &&
      !!!configValues?.waterAndWasteService?.hideService
    )
      cards.push({
        path: "/vann",
        header: "Vann og avløp",
        body: configValues?.waterAndWasteService?.cardText
          ? configValues?.waterAndWasteService?.cardText
          : "Informasjon om vannmåler og vannforbruk.",
      });    
  }
  return cards;
}
